import { Button as MUIButton, IconButton as MUIIconButton} from '@material-ui/core'
export const Button = (props) => (<MUIButton {...props} />)
export const IconButton = (props) => (<MUIIconButton {...props}/>)
